'use strict';

function resizeWindow() {}
function scrollDown() {}
/* ---- Menu Animations ---- */
var menuItems = $('.menu-background .container >ul li');
var secondaryMenu = $('header #secondary-nav, header #third-nav');
function ShowMenu() {
	var tl = new TimelineMax();
	tl.to($('.open-menu'), 0.5, { ease: Quad.easeInOut, marginLeft: -100, opacity: 0 }, 0).to($('#home h1'), 1, { ease: Quad.easeInOut, opacity: 0 }, 0).to($('.menu-background'), 0.5, { ease: Quad.easeInOut, height: 668, opacity: 1 }, 0).add(selectNextElement, tl.duration() / 3);
	function selectNextElement() {
		tl.to($('.close-menu'), 0.5, { ease: Quad.easeInOut, marginLeft: 0, opacity: 1 }, 0).to($('.close-menu .close-icon'), 1.5, { ease: Quad.easeInOut, rotationY: 360, transformOrigin: "center 0 0" }, 0).add(selectNextElement, tl.duration() / 3);
		function selectNextElement() {
			for (var i = 0; i < menuItems.length; i++) {
				tl.to(menuItems[i], 1, { ease: Quad.easeInOut, marginLeft: 0, opacity: 1 }, 0.3 * i);
			}
			setTimeout(function () {
				secondaryMenu.fadeIn();
			}, 300 * menuItems.length);
		}
	}
}
function hideMenu() {
	var tl = new TimelineMax();
	tl.to($('.open-menu'), 0.5, { ease: Quad.easeInOut, marginLeft: 0, opacity: 1 }, 0).to($('#home h1'), 1, { ease: Quad.easeInOut, opacity: 1 }, 0).to($('.menu-background'), 0.5, { ease: Quad.easeInOut, height: 0, opacity: 0 }, 0).add(selectNextElement, tl.duration() / 3);
	function selectNextElement() {
		tl.to($('.close-menu'), 0.5, { ease: Quad.easeInOut, marginLeft: 100, opacity: 0 }, 0).to($('.close-menu .close-icon'), 1.5, { ease: Quad.easeInOut, rotationY: 0, transformOrigin: "center 0 0" }, 0).add(selectNextElement, tl.duration() / 3);
		function selectNextElement() {
			for (var i = 0; i < menuItems.length; i++) {
				tl.to(menuItems[i], 1, { ease: Quad.easeInOut, marginLeft: -120, opacity: 0 }, 0.3 * i);
			}
			setTimeout(function () {
				secondaryMenu.fadeOut();
			}, 300 * menuItems.length);
		}
	};
}

$(document).ready(function () {
	/* aria-labelly for main nav navegation */
	$(".bottom-menu").html(function (buscayreemplaza, reemplaza) {
		return reemplaza.replace('<nav id="third-nav" role="navigation" aria-labelledby="third-nav">', '<nav id="third-nav-footer" role="navigation" aria-labelledby="third-nav-footer">');
	});
	$(".bottom-menu").html(function (buscayreemplaza, reemplaza) {
		return reemplaza.replace('<ul id="tertiary-navigation">', '<ul id="tertiary-navigation-footer">');
	});

	$(".middle-footer").html(function (buscayreemplaza, reemplaza) {
		return reemplaza.replace('<nav id="secondary-nav" role="navigation">', '<nav id="secondary-nav-footer" role="navigation">');
	});
	$(".middle-footer").html(function (buscayreemplaza, reemplaza) {
		return reemplaza.replace('<ul id="secondary-navigation">', '<ul id="secondary-navigation-footer">');
	});

	//Call function with browser is resized.
	$(window).resize(function (event) {
		resizeWindow();
	});
	resizeWindow();

	//Acts when scroll down page.
	$(window).scroll(function (event) {
		scrollDown();
		hideMenu();
		var top = $(document).scrollTop();
		if (top > 0) {} else {}
	});

	// Main Nav Dropdown
	$("#primary-nav li").hover(function () {

		$(this).addClass("hover");
		$('ul.submenu', this).fadeIn(200);
	}, function () {

		$(this).removeClass("hover");
		$('ul.submenu', this).fadeOut(200);
	});

	//Home page scroll down arrow. If present.
	$('.arrow-home').click(function (event) {
		$('body, html').animate({
			scrollTop: $(window).height() - $('header').outerHeight() * 2 }, 800, 'easeOutExpo');
	});

	//Event Tracking
	$('.book-now').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
	});
	$('.bookNow').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
	});

	//Check in and check out datepicker for booking engine
	$("#CheckIn").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		dateFormat: 'mm-dd-yy',
		onSelect: function onSelect(selectedDate) {
			getDate = $(this).datepicker('getDate');
			newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 1);
			$("#CheckOut").datepicker("setDate", newDate);
			$("#CheckOut").datepicker("option", "minDate", selectedDate);
		}
	});
	$("#CheckOut").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		dateFormat: 'mm-dd-yy',
		onSelect: function onSelect(selectedDate) {
			$("#CheckIn").datepicker("option", "maxDate", selectedDate);
		}
	});

	// Map: Return to previous page button. Change body id to match map template's name.
	//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

	$(".map-item, .item-post").click(function (event) {
		$(".map-item, .item-post").removeClass('active-pin');
		$(this).addClass('active-pin');
		var itemVal = $(this).attr('itemVal');
		var publication = $('.box-map');
		var finalTop;
		if ($(window).width() <= 1200) {
			finalTop = '10%';
		} else {
			finalTop = '20%';
		}
		publication.animate({
			opacity: 0,
			top: '-100%'
		}, 500);
		$('.box-' + itemVal).animate({
			opacity: 1,
			top: finalTop
		}, 500);
	});
	$(".close-box").click(function (event) {
		$(".map-item, .item-post").removeClass('active-pin');
		var publication = $('.box-map');
		publication.animate({
			opacity: 0,
			top: '-100%'
		}, 500);
	});

	function loadThumbs() {
		var activeSlide = $('.home-gallery-slider').find('.slick-active');
		var index = activeSlide.data('slick-index');
		var item_length = $('.home-gallery-slider .sym-slide').length - 1;
		var prev_row = $('.home-gallery-slider').find("[data-slick-index='" + (index - 1) + "']").find('.gallery-thumb').attr('src');
		var next_row = $('.home-gallery-slider').find("[data-slick-index='" + (index + 1) + "']").find('.gallery-thumb').attr('src');
		var actual_row = $('.home-gallery-slider').find("[data-slick-index='" + index + "']").find('.gallery-thumb').attr('src');

		if (item_length == index) {
			var next_row = $('.home-gallery-slider').find("[data-slick-index='" + 0 + "']").find('.gallery-thumb').attr('src');
		} else if (index == 0) {
			var prev_row = $('.home-gallery-slider').find("[data-slick-index='" + item_length + "']").find('.gallery-thumb').attr('src');
		};

		$('home-gallery-slider .slick-prev').append('<img style="opacity:0" src=" ' + prev_row + ' " alt="Previous" />');
		$('home-gallery-slider .slick-next').append('<img style="opacity:0" src=" ' + next_row + ' " alt="Next" />');
		$('home-gallery-slider .slick-arrow img').animate({
			opacity: 1
		}, 300);
		setTimeout(function () {
			$('.slick-arrow img:first-child').remove();
		}, 5800);
	}

	$(".show-box").click(function (event) {
		var link = $(this).parent().find('a');
		link.trigger('click');
	});

	$('.home-gallery-slider').on('afterChange', function (event, slick) {
		loadThumbs();
	});
	$('.home-gallery-slider').on('init', function (event, slick) {
		loadThumbs();
	});

	$('.home-gallery-slider').on('init', function (event, slick) {
		loadThumbs();
	});

	$('.open-menu').click(function () {
		ShowMenu();
	});
	$('.close-menu').click(function () {
		hideMenu();
	});

	$('.why-content').slick({
		arrows: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		accessibility: false,
		infinite: false
	});
});

$(window).on('load', function () {

	//Slick Slider
	$('.sym-slides').slick();
});